import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import About from "@/pages/about/page";
import Business from "@/pages/business/page";
import Case from "@/pages/case/page";
import CaseDetail from "@/pages/case/detail/page";
import Technology from "@/pages/technology/page";
import Overseas from "@/pages/overseas/page";
import Education from "@/pages/education/page";
import Cooperation from "@/pages/cooperation/page";
import News from "@/pages/news/page";
import NewsDetail from "@/pages/news/detail/page";
import Recruit from "@/pages/recruit/page";
import Contact from "@/pages/contact/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/about", element: <About /> },
  { path: "/business", element: <Business /> },
  { path: "/case", element: <Case /> },
  { path: "/case/:slug", element: <CaseDetail /> },
  { path: "/technology", element: <Technology /> },
  { path: "/overseas", element: <Overseas /> },
  { path: "/education", element: <Education /> },
  { path: "/cooperation", element: <Cooperation /> },
  { path: "/news", element: <News /> },
  { path: "/news/:id", element: <NewsDetail /> },
  { path: "/recruit", element: <Recruit /> },
  { path: "/contact", element: <Contact /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
